import { Controller } from 'react-hook-form';

import { InternationalPhoneInput, type InternationalPhoneInputProps } from '@eduzz/ui-antd-theme';

export type PhoneInput = InternationalPhoneInputProps;

const PhoneInput = ({ inputName, ...props }: PhoneInput) => {
  return (
    <Controller
      name={inputName || ''}
      render={({ field }) => (
        <InternationalPhoneInput
          defaultConfig={{ defaultCountry: 'br' }}
          {...field}
          inputName={field.name}
          {...props}
        />
      )}
    />
  );
};

export default PhoneInput;
